<template>
  <div
    class="control-camera-tree"
    :style="containerStyle"
    :class="{ 'el-form-item is-required': isRequired }"
  >
    <!-- <h3 class="title" v-if="titleShow" :class="{'el-form-item__label':isRequired}">{{$t('carPatrol.title.selectCamera')}}</h3> -->
    <div class="tree-content">
      <el-tree
        :props="props"
        :data="treeData"
        :show-checkbox="multiCheck"
        render-after-expand
        node-key="areaDevGroupCode"
        ref="grouptree"
        @current-change="handleCurrentChange"
        @check-change="handleCheckChange"
        @check="setNode"
        :render-content="renderContent"
      >
      </el-tree>
    </div>
    <div class="tree-footer" v-if="showConfirmBtn">
      <el-button type="primary" @click="confirmInfo">确认</el-button>
    </div>
  </div>
</template>

<script>
import { api } from "./api";

export default {
  props: {
    url: {
      type: String,
      default: () => {
        return "";
      },
    },
    isUpdate: {
      type: Boolean,
      default: false,
    },
    type: {
      // 1：车辆 2：人脸
      type: String,
      default: () => {
        return "1";
      },
    },
    isRequired: {
      // 是否显示*号
      type: Boolean,
      default: () => {
        return false;
      },
    },
    position: {
      // 容器位置
      type: Object,
      default: () => {
        return {
          right: "500px",
          top: "20px",
        };
      },
    },
    size: {
      // 容器大小
      type: Object,
      default: () => {
        return {
          width: "100%",
          height: "400px",
        };
      },
    },
    titleShow: {
      // 标题是否显示
      type: Boolean,
      default: () => {
        return true;
      },
    },
    bgColor: {
      // 背景颜色
      type: String,
      default: () => {
        return "#171C28";
      },
    },
    bayonetListType: {
      type: Number,
      default: () => {
        return 1;
      },
    },
    multiCheck: {
      type: Boolean,
      default: true,
    },
    showConfirmBtn: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      props: {
        label: "areaDevGroupName",
        children: "children",
      },
      treeData: [],
      bayonets: [], // 摄像机组数据
      cameraArr: [], // 全部摄像机数据
      aryList: [],
      checkedNodes: [],
    };
  },
  computed: {
    // 容器样式
    containerStyle() {
      return Object.assign(this.position, this.size, {
        backgroundColor: this.bgColor,
      });
    },
  },
  mounted() {
    // 获取摄像机组数据
    if (!this.isUpdate) {
      this.getTreeData();
    }
  },
  methods: {
    /*
     *@name: 渲染树图标
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-06-27 16:39:23
     */
    renderContent(h, { node, data, store }) {
      if (data.parentCode) {
        return (
          <span>
            <span>{node.label}</span>
          </span>
        );
      } else {
        return (
          <span>
            <i class="iconfont icon-Camera_group"></i>
            <span>{node.label}</span>
          </span>
        );
      }
    },
    /*
     *@name: 获取摄像机组数据
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-05-11 18:47:32
     */
    getTreeData(data, is = false) {
      this.$fetch(this.url ? this.url : api.querydeviceByArea, {
        type: this.type,
      }).then((res) => {
        if (res.returnObj && res.returnObj.length) {
          this.treeData = res.returnObj;
          this.recursionTreeData(this.treeData);
          if (is) {
            this.$refs.grouptree.setCheckedKeys(data);
          }
          this.$emit("cameraScatterPoint", this.cameraArr);
        }
      });
    },
    // 递归树
    recursionTreeData(data) {
      // console.log('data',data)
      if (!this.url) {
        data.forEach((item, index) => {
          // console.log('itemitem', item)
          // 取出所有摄像机
          if (item && item.cameraInfoList && item.cameraInfoList.length) {
            item.cameraInfoList.forEach((camera) => {
              this.cameraArr.push(camera);
            });
          } else {
            item.bayonet.forEach((cameraArr) => {
              if (
                cameraArr &&
                cameraArr.cameraInfoList &&
                cameraArr.cameraInfoList.length
              ) {
                cameraArr.cameraInfoList.forEach((camera) => {
                  this.cameraArr.push(camera);
                });
              }
            });
          }

          if (item.bayonet && item.bayonet.length) {
            item.bayonet.forEach((item) => {
              item.areaDevGroupName = item.bayonetName;
            });
            if (item.children) {
              item.children = item.children.concat(item.bayonet);
            } else {
              item.children = item.bayonet;
            }
          }
          console.log("000", this.treeData);
          if (item.children) {
            this.recursionTreeData(item.children);
          }
        });
      } else {
        data.forEach((item, index) => {
          // console.log('itemitem12356', item)
          // 取出所有区域
          item.children = item.areaChildren;
          if (item.children) {
            this.recursionTreeData(item.children);
          }
        });
      }
    },
    resetTreeData() {
      this.treeData = [];
      this.getTreeData();
    },
    /*
     *@name: 递归取出摄像机组
     *@param:{type}
     *@description:
     *@return:
     *@author: panlua
     *@date: 2019-05-10 16:48:01
     */
    recursionBayonets(data) {
      if (data.children && data.bayonet.length === data.children.length) {
        data.bayonet.forEach((item) => {
          this.bayonets.push(item);
        });
      }
    },
    handleCurrentChange(data, node, current) {
      const { areaDevGroupName, areaDevGroupCode } = data;
      this.$emit("current-change", data, node, current);
    },
    handleCheckChange(data, checked) {
      const selectedDevices = this.$refs.grouptree.getCheckedNodes();
      this.bayonets.length = 0;
      selectedDevices.forEach((item) => {
        if (item.parentCode) {
          this.bayonets = this.bayonets.concat(item.bayonet);
        }
        if (item.bayonetName) {
          this.bayonets.push(item);
        }
      });
      let cameraArr = [];
      this.bayonets.forEach((item) => {
        cameraArr = cameraArr.concat((item && item.cameraInfoList) || []);
      });
      this.$emit("change", this.bayonets, cameraArr);
    },
    setNode(data, list) {
      this.checkedNodes = list.checkedNodes;
      if (!this.url) {
        let aryList = [];
        list.checkedNodes.map((val) => {
          if (val.bayonetName) {
            aryList.push(val);
          }
        });
        this.aryList = aryList;
        this.$emit("changeCamersGroup", aryList, this.bayonetListType);
      } else {
        this.$emit("changeCamersGroup", list.checkedNodes);
      }
    },
    confirmInfo() {
      if (!this.url) {
        this.$emit("confirmCamersGroup", this.aryList, this.bayonetListType);
      } else {
        this.$emit("confirmCamersGroup", this.checkedNodes);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.control-camera-tree {
  position: absolute;
  z-index: 10;
  border-radius: 6px;
  padding: 10px;
  display: flex;
  flex-direction: column;
  .title {
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;
    text-align: left;
    line-height: 20px;
    margin: 0;
    padding: 0;
  }
  .tree-content {
    flex: 1;
    overflow-y: auto;
  }
  .tree-footer {
    text-align: right;
  }
}
</style>
